import { render, staticRenderFns } from "./pesananpascabayar.vue?vue&type=template&id=1ab78482"
import script from "./pesananpascabayar.vue?vue&type=script&lang=js"
export * from "./pesananpascabayar.vue?vue&type=script&lang=js"
import style0 from "./pesananpascabayar.vue?vue&type=style&index=0&id=1ab78482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports